<template>

	<div>

		<div class="flexcenter" style="margin-bottom:10px;">
			<h3 :class="this.darkMode ? 'font-dark' : 'font-light'">{{ this.title }}</h3><br />
		</div>



		<div id="box-grid" style="padding:0px;align-items: stretch;gap:10px;" class="flexcenter"
			title="Välj mc-märke och mc-modell">


			<div class="box box-brand" style="" :class="this.darkMode ? 'dark' : 'light'">
				<div class="label flexcenter">
					<b>Märke</b>
				</div>

				<select class="desktop" v-if="this.baseMcTree" v-model="this.searchProductConfig.brand" size="10"
					@change="this.resetSearchProductConfig()">
					<option v-for="(brand) in this.baseMcTree" :key="brand.id" :value="brand">{{ brand.name }}</option>
				</select>
				<select class="mobile" v-if="this.baseMcTree" v-model="this.searchProductConfig.brand" size="1"
					@change="this.resetSearchProductConfig()">
					<option v-for="(brand) in this.baseMcTree" :key="brand.id" :value="brand">{{ brand.name }}</option>
				</select>
			</div>

			<div class="box box-modell" style="" :class="this.darkMode ? 'dark' : 'light'">
				<div class="flexcenter label" style="align-items:start;">
					<b style="flex-grow:1;">Modell</b>
					<Circle :fileName="this.darkMode ? 'w3_search_light' : 'w3_search_white'" padding="20%" size="20px"
						:color="this.darkMode ? '--grey-dark-3' : '--grey-5' "
						@click="this.showSearch = !this.showSearch; this.filterInput = null;" />

				</div>
				<transition name="slide">
					<div v-if="this.showSearch" class="search-wrapper" style="display: block;">
						<div class="form textField" title="Sök mcmodell"
							style="width:calc(100% - 10px);margin-bottom:10px;margin-top:5px;">
							<input type="text" placeholder="Sök mc-modell" v-model="this.filterInput" />
							<img src="@/assets/w3_button_close_light.png" @click="this.filterInput = null;">
						</div>

					</div>

				</transition>

				<select v-if="this.baseMcTree" class="desktop" v-model="this.searchProductConfig.mc" size="10"
					@change="this.resetSearchProductConfig()">

					<option v-for="mc in this.modelList" :key="mc.mcId" :value="mc">{{ mc.modelName }}
					</option>

				</select>
				<select v-if="this.baseMcTree" class="mobile" v-model="this.searchProductConfig.mc"
					:size="this.filterInput ? '5' : '1' " @change="this.resetSearchProductConfig()">

					<option v-for="mc in this.modelList" :key="mc.mcId" :value="mc">{{ mc.modelName }}
					</option>

				</select>

			</div>

			<div class="box box-year" :class="this.darkMode ? 'dark' : 'light'">
				<div class="label flexcenter">
					<b>Årsmodell</b>
				</div>

				<select class="desktop" v-if="this.baseMcTree" v-model="this.searchProductConfig.year"
					@change="yearSelectedMV();" size="10">
					<option v-for="year in this.yearList" :key="year.year" :value="year">{{ year.year }}</option>
				</select>

				<select class="mobile" v-if="this.baseMcTree" v-model="this.searchProductConfig.year"
					@change="yearSelectedMV();" size="1">
					<option v-for="year in this.yearList" :key="year.year" :value="year">{{ year.year }}</option>
				</select>

			</div>



		</div>


		<div>


			<Button label="Visa produkter" style="margin-top:10px;" @click="() => { this.modelPickerComplete() }" />
		</div>
	</div>
</template>
<script>
import listHelper from '../../helper/list-helper';
import { STORE_GETTER } from '../../store/store';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "PopoverModelPicker",
	components: {},
	mixins: [],
	props: {
		show: Boolean, // eftersom vyn alltid visas så att den kan animeras. 
		darkMode: {
			type: Boolean,
			default: false
		},
		title:{
			type: String,
			default: "Modellväljaren"
		}

	},
	data() {
		return {
			filterInput: null,
			showSearch: false,


		};
	},
	computed: {

		searchProductConfig() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},

		baseMcTree() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.mcTree) {
				return baseModel.mcTree
			}

			return null;

		},

		modelList(){
			
			if (this.searchProductConfig.brand && this.searchProductConfig.brand.modelList){

				if (!this.filterInput){
					return this.searchProductConfig.brand.modelList
				}

				var modelList = this.searchProductConfig.brand?.modelList?.filter(model => model != null);
				
				return modelList.filter(model => {


					// manufactor.search 
					const modelName = model.modelName
					const filterInput = this.filterInput
					const modelNameSpace = modelName?.replaceAll(" ", "");
					const filterInputSpace = filterInput?.replaceAll(" ", "");

					return listHelper.filter(modelName, filterInput) || listHelper.filter(modelNameSpace, filterInputSpace)

				})
				

			}

			return null;
		},
		yearList(){
			return this.searchProductConfig.mc && this.searchProductConfig.mc.yearList?.filter(year => year !== null).sort((a, b) => b.year - a.year)
		}



		

	},
	watch: {
		
		"searchProductConfig.brand": {
			handler(brand) {

				if (!this.show){
					return
				}

				this.searchProductConfig.productGroupKey = null

				this.searchProductConfig.mc = null
				this.searchProductConfig.year = null

				console.log('FP: this.searchProductConfig.brand route ', brand?.name);
			},
		},

		"searchProductConfig.mc": {
			handler(mc) {

				if (!this.show) {
					return
				}

				this.searchProductConfig.productGroupKey = null
				this.searchProductConfig.year = null
				
				console.log('FP: this.searchProductConfig.mc route ', mc?.key);

			},
		},


		"searchProductConfig.year": {
			handler(year) {

				this.searchProductConfig.productGroupKey = null
				
				if (!this.show) {
					return
				}

				console.log('FP: this.searchProductConfig.year route ', year);

			},
		},
	},
	methods: {

		yearSelectedMV() {
			if (this.searchProductConfig.brand == null) {
				//alert("brand");
				return;
			}

			if (this.searchProductConfig.mc == null) {
				alert("mc");
				return;
			}


			//this.hideAllPageMenu()
			this.resetSearchProductConfig();
			this.modelPickerComplete();

		},

		hideAllPageMenu() {
			//alert("hideAllPageMenu")
			//this.modelPickerComplete();
			this.$emit("modelPickerCancel");
		},

		modelPickerComplete(){
			this.$emit("modelPickerComplete");
		},

		resetSearchProductConfig() {
			this.searchProductConfig.manufactor = null;
			this.searchProductConfig.category = null;

			this.searchProductConfig.searchPhrase = '';
		},

	},
	created() {

	}
};
</script>

<style scoped>

div#box-grid{
	flex-direction: row;
}
div#box-grid div.box.box-brand{
	width: 200px;
}

div#box-grid div.box.box-year {
	width: 150px;
}
div#box-grid div.box.box-modell {
		flex-grow: 1;
		max-width: 300px;
}

@media (max-width:768px) {
	div#box-grid {
		flex-direction: column;
	}


	div#box-grid div.box.box-brand,
	div#box-grid div.box.box-modell,
	div#box-grid div.box.box-year {
		width: calc(100% - 20px);
		max-width: none;
		flex-grow: 0;
	}
}

div.flexcenter div.box select{
	width:100%;
	flex-grow:1;
	border: none;
	
	
}

div.flexcenter div.box {
	display: flex;
	flex-direction: column;
	padding:5px;
	border:1px solid var(--grey-3);
	border-radius: 5px;
	background: var(--grey-1);
}

div.flexcenter div.box.dark {
	background: var(--grey-3);
}

div div.flexcenter div b{
	margin-left:4px;
}

div.box div.label b{
	margin-bottom:5px;
}

div.box select option{
	padding:3px;
	padding-top:5px;
	padding-bottom:5px;
}

.slide-enter-active,
.slide-leave-active {
	transition: height 0.3s ease, opacity 0.2s ease;
	overflow: hidden;
}

.slide-enter-from,
.slide-leave-to {
	height: 0;
	opacity: 0;
}

.slide-enter-to,
.slide-leave-from {
	height: 45px;
	opacity: 1;
}

.search-wrapper {
	display: block;
}

.font-dark{
	color: white;
}
</style>